<template>

<div>
    <el-row>
        <el-col :span="24">
            <div class="grid-content bg-purple-light">
                <div class="searchTitle">
                    <b style="font-size: 20px !important;">   품목   </b>
      </div>

<!--      &lt;!&ndash; 조회 조건 영역 &ndash;&gt;-->
<!--      <div class="searchBody">-->
<!--        &lt;!&ndash; 조회 조건 영역 &ndash;&gt;-->
<!--          <div class="searchBody_year" style="font-size: 15px !important;">-->
<!--          생성 일자-->
<!--          </div>-->
<!--          <div style="margin-left: 10px">-->
<!--          <el-date-picker-->
<!--            v-model="confirmStartDateOption"-->
<!--            type="date"-->
<!--            placeholder="Pick a day"-->
<!--            value-format="yyyy-MM-dd"-->
<!--            class="date-input"-->
<!--          >-->
<!--          </el-date-picker>-->
<!--          ~-->
<!--          <el-date-picker-->
<!--            v-model="confirmEndDateOption"-->
<!--            type="date"-->
<!--            placeholder="Pick a day"-->
<!--            value-format="yyyy-MM-dd"-->
<!--            class="date-input"-->
<!--          >-->
<!--          </el-date-picker>-->
<!--          </div>-->
<!--      </div>-->

      <div class="searchBody">
        <!-- 조회 조건 영역 -->
        <div class="searchBody_year" style="font-size: 15px !important;">
          품목:
        </div>
        <div style="margin-left: 18px">
          <el-input
              placeholder=""
              v-model="countryInput"
              class="wide-input"
              style="margin-left: 10px;"
          >
          </el-input>
        </div>
      </div>



<!--      <div class="searchBody">-->
<!--        &lt;!&ndash; 조회 조건 영역 &ndash;&gt;-->
<!--        <div class="searchBody_year" style="font-size: 15px !important;">-->
<!--          판매처명-->
<!--        </div>-->
<!--        <div >-->
<!--          <el-input-->
<!--              placeholder=""-->
<!--              v-model="storeInput"-->
<!--                            class="wide-input"-->
<!--              style="margin-left: 10px;"-->
<!--          >-->
<!--          </el-input>-->
<!--        </div>-->
<!--      </div>-->



<!--      <div class="searchBody">-->
<!--        &lt;!&ndash; 조회 조건 영역 &ndash;&gt;-->
<!--        <div class="searchBody_production" style="margin-right: 0px;width: 80px !important;">-->
<!--          QR 리딩 건수-->
<!--        </div>-->

<!--        <div>-->
<!--        <el-radio v-model="countFlag"  label="All" style="margin-right: 5px !important; padding-left: 2px !important;">전체</el-radio>-->
<!--        <el-radio v-model="countFlag"   label="Complete" style="margin-right: 5px !important; padding-left: 2px !important;">리딩완료</el-radio>-->
<!--          <el-radio v-model="countFlag"   label="Incomplete" style="margin-right: 5px !important; padding-left: 2px !important;">리딩 미완료</el-radio>-->
<!--          <el-radio v-model="countFlag"   label="Over" style="margin-right: 5px !important; padding-left: 2px !important;">리딩 오버</el-radio>-->
<!--        </div>-->

<!--      </div>-->



      <div class="searchBody"            >

        <div class="searchBody_brand">
          <el-button
            :loading="loading"
            type="primary"
            @click="search"
          >Search</el-button>
          </div>
      </div>


    </div> <!-- div class="grid-content bg-purple-light"> -->
  </el-col>

</el-row>

    <el-row>
        <el-col :span="20">
            <div class="grid-content bg-purple-light" >

 <el-table
    v-loading="loading"
    ref="multipleTable"
    :data="tableData"

    border
    @selection-change="handleSelectionChange"
     :row-class-name="tableRowClassName"
    size="small"
    :row-style="{ height: 0 + 'px' }"
    :cell-style="{ padding: 0 + 'px' }"
    :header-cell-style="{
                          background: '#2F384E',
                          color: '#fff',
                          height: '10px',
                          padding: '0px',
                        }"
 >
    <el-table-column
      type="selection"
      width="35"
      >
    </el-table-column>


    <el-table-column
        property="seq"
      label="일련번호"
      width="80">
    </el-table-column>

     <el-table-column label="등록 시간" width="180">
         <template #default="scope">
             {{ scope.row.insert_date_ktng ? scope.row.insert_date_ktng.substring(0, 16) : '' }}
         </template>
     </el-table-column>

   <el-table-column
       property="country"
       label="품목"
       width="200">

       <template slot-scope="scope">
           <el-input
                   id="bigo2"
                   size="small"
                   placeholder=""
                   v-model="scope.row.country"
                   style="width: 180px !important"
           >
           </el-input>
       </template>
   </el-table-column>


   <el-table-column
       property="amount"
       label="QR 수량"
       width="150">
       <template slot-scope="scope">
           <el-input
                   id="bigo2"
                   size="small"
                   placeholder=""
                   v-model="scope.row.amount"
                   style="width: 130px !important"
           >
           </el-input>
       </template>
   </el-table-column>

 </el-table>




 <el-row>
  <el-col :span="24"><div class="pagination"  >

<el-pagination
  small
  layout="prev, pager, next"
      :total="totalSize"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page.sync="currentPage"
      :page-size="pageSize"
  >
</el-pagination>


    <el-button
        :loading="loading"
        type="primary"
        @click="dialogVisible2=true"
    >품목 생성</el-button>


      <el-button
              :loading="loading"
              type="primary"
              @click="update"
      >수정</el-button>


      <el-button
              :loading="loading"
              type="primary"
              @click="handleDelete"
      >삭제</el-button>



      <el-button
        :loading="loading"
        type="primary"
        @click="excelDownFuncAll"
        style="margin-left: 10px"
    > 엑셀 다운로드 </el-button>


<!--    <el-button-->
<!--        :loading="loading"-->
<!--        type="primary"-->
<!--        @click="excelDownFuncAll"-->
<!--        style="margin-left: 10px"-->
<!--    > 엑셀 다운로드 </el-button>-->



    <el-tag type="warning" effect="dark"  style="margin-left: 10px; height: 30px"> TOTAL COUNT : {{this.totalData.length}}</el-tag>

  </div>
  </el-col>
 </el-row>


    <el-dialog
  title="발행결과 파일 업로드"
  :visible.sync="dialogVisible"
  width="30%"
  v-loading="loading"
  :before-close="Confirm"
  :close-on-click-modal="false"
  >
    <span class="text-reader">
      <form ref="form">

      <input type="file" @change="filesChange" class="FileUpload__default" accept=".xlsx" multiple  />
      </form>
    </span>

    <span slot="footer" class="dialog-footer">
    <!-- <el-button @click="dialogVisible = false">Cancel</el-button> -->
    <el-button type="primary" @click="Confirm">Confirm</el-button>
  </span>


</el-dialog>



                <el-dialog
                        title="품목생성"
                        :visible.sync="dialogVisible2"
                        width="450px"
                        height="200px"
                        v-loading="loading"
                        :before-close="Confirm2"
                        :close-on-click-modal="false"
                        custom-class="rounded-dialog"
                >
        <el-row>
            <el-col >
                <div style="margin-top: 0px">

                  <div class="searchBody">
                    <!-- 조회 조건 영역 -->
                    <div class="searchBody_year" style="font-size: 15px !important;">
                      품목
                    </div>
                    <div style="margin-left: 22px">
                      <el-input
                          placeholder=""
                          v-model="country"
                          class="wide-input"

                      >
                      </el-input>
                    </div>
                  </div>

                  <div class="searchBody">
                    <!-- 조회 조건 영역 -->
                    <div class="searchBody_year" style="font-size: 15px !important;">
                      수량
                    </div>
                    <div style="margin-left: 22px">
                      <el-input
                          placeholder=""
                          v-model="amount"
                          class="wide-input"
                      >
                      </el-input>
                    </div>
                  </div>

              </div>
            </el-col>
          </el-row>



        <div class="searchBody_production">
       <el-button type="primary" @click="insert">등록 </el-button>

        </div>

    </el-dialog>





  </div>
 </el-col>
 </el-row>

</div>
</template>


<script>
import Axios from 'axios';
import XLSX from "xlsx";


  export default {
    created() {
      this.$store.commit("dayBefore",0);
      this.confirmEndDateOption = this.$store.state.dateOption; // 조회조건에서 현재 날짜 
      this.$store.commit("dayBefore",7);
      this.confirmStartDateOption = this.$store.state.dateOption; // 조회조건이서 현재보다 -7 일
      if (this.$store.state.userId != 'admin') {
        // this.deptSeqOption = this.$store.state.deptSeq;
        // this.deptNameOption = this.$store.state.deptName;
      }

      // console.log()
      // 페이지로딩시 조회
      this.search();
      // this.getFilePath();
    },//created    
    data() {
      return {
        // table 관련 data 
        tableData: [],
        totalData: [],
        totalData2: [],
        tableData2:[],
        multipleSelection: [],
        multipleTable2 :[],

        saveData:[],
        saveData2:[],
        currentPage: 1,
        pageSize:10,
        totalSize:0,

        // loading 변수 true 이면 loging 화면 보여줌
        loading:false,

        statusOptions: [{

          value: 'I',
          label: '입고'
        },
          {
          value: 'O',
          label: '출고'
        }, ],
        brandOption: '',
        styleOption :'',
        deptNameOption:'',
        deptSeqOption:0,
        confirmStartDateOption:'',
        confirmEndDateOption:'',
        statusOption:'입고',
        status:'',     
        fileList: [],
        text :[],
        dialogVisible: false,
        dialogVisible2:false,
        dialogVisible3:false,
        statusLavel:'',
        filePath:'',
        epc :'',
        member_id :'',
        member_name : '',
        chkOutDate : false,
        items : [],
        excelJsonData :  [],
        qrcode : '',
        qrcode2 : '',
        inputQrCode : '',
        inputBigQrCode : '',
        countFlag:'All',
        waybill_number : '',
        big_qr_code : '',
        inPutFlag : 0,
        autoSave  : true, 
        inputWayBillNumber :'',
        countryInput :'',
        storeInput :'',
        bigoInput :'',
        store :'',
        country :'',
        bigo : '',
          amount : 0,


      } // return 
    },// data

    methods: {

      inputChange(event){
        // console.log(event)
        //
        // console.log(event.length)
        //

        if (this.autoSave) {

          if (event.substr(-1) == '\n') {
            this.inPutFlag = 1 + this.inPutFlag;
          }

          if (this.inPutFlag == 2) {
            this.qrSave();
            this.qrcode = "";
            this.inPutFlag = 0;
          }
        }
      },

      handleClick1(big_qr_code ){
        this.search2(big_qr_code);
      },


      async search2(big_qr_code) {
        this.loading = true;
        this.dialogVisible2 = false;
        this.dialogVisible3 = false;
        this.big_qr_code = big_qr_code;

        // default data
        let url = this.$url + '/claWayBillInfo/getQrList';
        var reqJson = new Object();

        reqJson.big_qr_code = big_qr_code;
        //console.log("============================================================") ;
        //console.log(reqJson) ;

        await Axios.post(url, reqJson , this.$store.state.config ).then(res => {
          var resDataJson = res.data.claBarcodeInfoDTO;

          this.qrcode2 = "";
          this.qrcode2 = big_qr_code + '\n'
          for(var resData in resDataJson){
            this.qrcode2 = this.qrcode2 + resDataJson[resData]['waybill_number'] + '\n'
          }
          this.loading = false;
          this.dialogVisible3 = true;
        }) // await Axios.post
            .catch(error => {
              console.log(error.response)
              this.$message.error(this.$store.state.serverErrorMessage);
              this.loading = false;
            }); // await Axios.post
      },//

      async search(){
        this.loading = true;
        // default data
        let url = this.$url + '/authStoreInfo/list';
        var reqJson = new Object();

        reqJson.in_start_date = this.confirmStartDateOption;
        reqJson.in_end_date = this.confirmEndDateOption;
        reqJson.country = this.countryInput;
        reqJson.store = this.storeInput;
        reqJson.user_seq = 173

        await Axios.post(url, reqJson , this.$store.state.config ).then(res => {
          var resDataJson = res.data.authStoreInfoDTO;
          this.totalData=[];

          if (res.data.resultCode){
            for (var resData in resDataJson) {
                this.totalData.push({
                  seq: resData  * 1 + 1
                  , insert_date : resDataJson[resData]['insert_date']
                  , insert_date_ktng :   resDataJson[resData]['insert_date_ktng']
                  , country : resDataJson[resData]['country']
                  , amount : resDataJson[resData]['amount']
                  , bigo : resDataJson[resData]['bigo']
                  , user_seq : resDataJson[resData]['user_seq']
                  , auth_store_info_seq :  resDataJson[resData]['auth_store_info_seq']
                });
            }
            // 전체 데이터 사이즈
            this.totalSize = this.totalData.length;
            // 보여주는 부분만 slice
            this.tableData = this.totalData.slice(0, this.pageSize);
            this.currentPage = 1;
            this.loading = false;
            this.status = reqJson.status;
            this.$message.success(this.$store.state.searchSuccess);
          }else{
            this.$message.error(this.$store.state.dataNotFound);
            this.currentPage = 1;
            this.loading = false;
          }
        }) // await Axios.post
        .catch(error => {
          console.log(error.response)
          this.$message.error(this.$store.state.serverErrorMessage);
          this.currentPage = 1;
          this.loading = false;
        }); // await Axios.post
      },//search

      toggleSelection(rows) {
        if (rows) {
          rows.forEach(row => {
            this.$refs.multipleTable.toggleRowSelection(row);
          });
        } else {
          this.$refs.multipleTable.clearSelection();
        }
      }, //toggleSelection

      // check box click event 
      handleSelectionChange(val) {
        this.multipleSelection = val;
      },
      tableRowClassName({row, rowIndex}) {
        if (rowIndex === 1) {
        //  return 'warning-row';
        } else if (rowIndex === 3) {
        //  return 'success-row';
        }
         console.log(row);
        return '';
      },    
      handleSizeChange(val) {
        console.log(`${val} items per page`);
      },

      // pagging event 
      handleCurrentChange(val) {
        this.tableData = this.totalData.slice( (this.pageSize * val - this.pageSize )   , this.pageSize * val);
      },
      //
      // async excelDownFunc(){
      //
      //   if(this.multipleSelection==null || this.multipleSelection.length == 0 ){
      //     this.$message.error(this.$store.state.noDataSelect);
      //     return ;
      //   }
      //
      //   this.loading = true;
      //
      //   // default data
      //   let url = this.$url + '/rfidInfo/reDowload';
      //   // var reqJson = new Object();
      //
      //   await Axios.post(url, this.multipleSelection , this.$store.state.config ).then(res => {
      //     let saveCount = res.data;
      //
      //
      //     if (saveCount){
      //       this.$message.success(saveCount +'건 ' + this.$store.state.saveSuccess);
      //       this.loading = false;
      //
      //     }else{
      //       this.$message.error(this.$store.state.serverErrorMessage);
      //       this.currentPage = 1;
      //       this.loading = false;
      //     }
      //   }) // await Axios.post
      //       .catch(error => {
      //         console.log(error.response)
      //         this.$message.error(this.$store.state.serverErrorMessage);
      //         this.currentPage = 1;
      //         this.loading = false;
      //       }); // await Axios.post
      //
      //
      // }, //excelDownFunc



      async pathUpload(){


        this.loading = true;

        // default data
        let url = this.$url + '/saveInfo/pathUpdate';
        var reqJson = new Object();


        reqJson.file_full_path = this.filePath;

        await Axios.post(url, reqJson , this.$store.state.config ).then(res => {
          let saveCount = res.data;

          if (saveCount){
            this.$message.success(saveCount +'건 ' + this.$store.state.saveSuccess);
            this.loading = false;

          }else{
            this.$message.error(this.$store.state.serverErrorMessage);
            this.currentPage = 1;
            this.loading = false;
          }
        }) // await Axios.post
            .catch(error => {
              console.log(error.response)
              this.$message.error(this.$store.state.serverErrorMessage);
              this.currentPage = 1;
              this.loading = false;
            }); // await Axios.post


      }, //excelDownFunc

      getCheckSum(hex)
      {
        var chk = hex.length
        var value = 0;
        for(var i=0; i <hex.length; i += 2) {
          value +=  parseInt(hex.substring(i, i+2),16) * chk
          chk ++;
        }
        var res = value * 1224 % 100;
        if (res <= 9)
          return '0' + res;
        else
          return res;
      },

      convertToHex(str) {
          var hex = '';
          for(var i=0;i<str.length;i++) {
            hex += str.charCodeAt(i).toString(16);
          }
        return hex;
      },

      convertToString(hex) {

        //console.log("convertToString");
        //console.log(hex);

        var str = '';
        for(var i=0;i<hex.length; i += 2) {
          str += String.fromCharCode(parseInt(hex.substring(i, i+2),16))
        }
        return str;
      },

      filesChange(event) {
        // get File object from input tag
        this.loading = true;

        const file = event.target.files[0];
        let reader = new FileReader();
        let tmpResult = {};
        reader.onload = (e) => {

          console.log(e);

          let data = reader.result;
          let workbook = XLSX.read(data, {type: 'binary'});
          workbook.SheetNames.forEach(sheetName => {
            workbook.Sheets[sheetName].A1.w = "region";
            workbook.Sheets[sheetName].B1.w = "waybill_number";
            workbook.Sheets[sheetName].C1.w = "sender";
            workbook.Sheets[sheetName].D1.w = "sender_hp";

            workbook.Sheets[sheetName].E1.w = "sender_manager";
            workbook.Sheets[sheetName].F1.w = "sender_manager_hp";
            workbook.Sheets[sheetName].G1.w = "sender_zip_code";
            workbook.Sheets[sheetName].H1.w = "sender_address";

            workbook.Sheets[sheetName].I1.w = "receiver";
            workbook.Sheets[sheetName].J1.w = "receiver_hp";
            workbook.Sheets[sheetName].K1.w = "receiver_manager";
            workbook.Sheets[sheetName].L1.w = "receiver_manager_hp";

            workbook.Sheets[sheetName].M1.w = "receiver_zip_code";
            workbook.Sheets[sheetName].N1.w = "receiver_address";
            workbook.Sheets[sheetName].O1.w = "fare_type";

            workbook.Sheets[sheetName].P1.w = "payment_type";
            workbook.Sheets[sheetName].Q1.w = "release_number";


            workbook.Sheets[sheetName].R1.w = "remark";

            workbook.Sheets[sheetName].S1.w = "memo1";
            workbook.Sheets[sheetName].T1.w = "memo2";

            workbook.Sheets[sheetName].U1.w = "memo3";
            workbook.Sheets[sheetName].V1.w = "memo4";

            workbook.Sheets[sheetName].W1.w = "lbl_hub_code";
            workbook.Sheets[sheetName].X1.w = "product_name1";
            workbook.Sheets[sheetName].Y1.w = "product_count1";


            workbook.Sheets[sheetName].Z1.w = "product_name2";
            workbook.Sheets[sheetName].AA1.w = "product_count2";
            workbook.Sheets[sheetName].AB1.w = "product_name3";
            workbook.Sheets[sheetName].AC1.w = "product_count3";


            workbook.Sheets[sheetName].AD1.w = "product_name4";
            workbook.Sheets[sheetName].AE1.w = "product_count4";
            workbook.Sheets[sheetName].AF1.w = "product_name5";
            workbook.Sheets[sheetName].AG1.w = "product_count5";

            workbook.Sheets[sheetName].AH1.w = "product_name6";
            workbook.Sheets[sheetName].AI1.w = "product_count6";
            workbook.Sheets[sheetName].AJ1.w = "product_name7";
            workbook.Sheets[sheetName].AK1.w = "product_count7";



            workbook.Sheets[sheetName].AL1.w = "product_name8";
            workbook.Sheets[sheetName].AM1.w = "product_count8";

            workbook.Sheets[sheetName].AN1.w = "product_name9";


            workbook.Sheets[sheetName].AO1.w = "product_count9";
            workbook.Sheets[sheetName].AP1.w = "product_name10";
            workbook.Sheets[sheetName].AQ1.w = "product_count10";
            workbook.Sheets[sheetName].AR1.w = "product_name11";


            workbook.Sheets[sheetName].AS1.w = "product_count11";
            workbook.Sheets[sheetName].AT1.w = "product_name12";


            workbook.Sheets[sheetName].AU1.w = "product_count12";


            workbook.Sheets[sheetName].AV1.w = "product_name13";


            workbook.Sheets[sheetName].AW1.w = "product_count13";
            workbook.Sheets[sheetName].AX1.w = "product_name14";
            workbook.Sheets[sheetName].AY1.w = "product_count14";
            workbook.Sheets[sheetName].AZ1.w = "product_name15";




            workbook.Sheets[sheetName].BA1.w = "product_count15";
            workbook.Sheets[sheetName].BB1.w = "product_name16";
            workbook.Sheets[sheetName].BC1.w = "product_count16";
            workbook.Sheets[sheetName].BD1.w = "product_name17";
            workbook.Sheets[sheetName].BE1.w = "product_count17";
            workbook.Sheets[sheetName].BF1.w = "product_name18";


            workbook.Sheets[sheetName].BG1.w = "product_count18";
            workbook.Sheets[sheetName].BH1.w = "product_name19";
            workbook.Sheets[sheetName].BI1.w = "product_count19";
            workbook.Sheets[sheetName].BJ1.w = "product_name20";


            workbook.Sheets[sheetName].BK1.w = "product_count20";
            workbook.Sheets[sheetName].BL1.w = "product_name21";
            workbook.Sheets[sheetName].BM1.w = "product_count21";
            workbook.Sheets[sheetName].BN1.w = "product_name22";


            workbook.Sheets[sheetName].BO1.w = "product_count22";
            workbook.Sheets[sheetName].BP1.w = "product_name23";
            workbook.Sheets[sheetName].BQ1.w = "product_count23";


            workbook.Sheets[sheetName].BR1.w = "product_name24";
            workbook.Sheets[sheetName].BS1.w = "product_count24";
            workbook.Sheets[sheetName].BT1.w = "product_name25";
            workbook.Sheets[sheetName].BU1.w = "product_count25";


            workbook.Sheets[sheetName].BV1.w = "product_name26";
            workbook.Sheets[sheetName].BW1.w = "product_count26";


            //console.log(workbook.Sheets[sheetName].A1);
            const roa = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName]);
            tmpResult = roa;
          });

          //console.log("=====================================");
          //console.log(tmpResult);
          this.excelJsonData=tmpResult;


          let url = "";
          url = this.$url + '/claWayBillInfo/insert';

          Axios.post(url, this.excelJsonData , this.$store.state.config  ).then(res => {

            //console.log(res);
            let saveCount = res.data;
            this.loading = false;
            this.$message.success(saveCount +'건 ' + this.$store.state.saveSuccess);
            this.search();
            // this.$refs.myFiles.files[0].name = null;
          }).catch(error => {
            console.log(error.response)
            this.$message.error(this.$store.state.serverErrorMessage);
            this.currentPage = 1;
            this.loading = false;
          }); // await Axios.post



        };
        reader.readAsBinaryString(file);
              
      },//filesChange

      Confirm(){
        // this.e.target.files[0].name = "";

        this.$refs.form.reset() ;
        this.dialogVisible = false;
        this.dialogVisible2 = false;
        this.search();

      },

      Confirm2(){
        // this.e.target.files[0].name = "";

        //console.log ("Confirm2") ;
        this.country = "";
        this.store = "";
        this.bigo="";
        this.dialogVisible2 = false;
        this.search();

      },

      Confirm3(){
        // this.e.target.files[0].name = "";

        this.qrcode2 = "";
        this.dialogVisible3 = false;

      },




        async update(){

            // 1. 선택된 데이터가 없는지 먼저 체크 (잘 하셨습니다)
            if (this.multipleSelection.length <= 0) {
                this.$message.error("데이터를 선택하세요 ");
                return;
            }

// 2. [수정] for...in 대신 for...of 사용 (객체를 바로 가져옴)
            for (const item of this.multipleSelection) {

                // [개선] country 속성이 있는지 확인하고 공백 체크
                // 만약 한 글자 허용하려면 조건은 유지하되 메시지를 "2글자 이상"으로 바꾸는 게 좋습니다.
                // 여기서는 '반드시 입력' 조건으로 수정했습니다.
                if (!item.country || item.country.toString().trim().length === 0) {
                    this.$message.error("품목명을 입력해주세요");
                    return;
                }

                // [개선] amount 속성이 존재하고 비어있지 않은지 체크
                if (!item.amount || item.amount.toString().trim().length === 0) {
                    this.$message.error("수량을 입력해주세요");
                    return;
                }

                // 3. 정규표현식으로 숫자만 있는지 체크 (잘 하셨습니다)
                const numericRegex = /^[0-9]+$/;
                // item.amount로 바로 접근
                if (!numericRegex.test(item.amount)) {
                    this.$message.error("수량은 숫자만 입력 가능합니다");
                    return;
                }
            }
// 모든 검증 통과 후 로직 실행

            let url = this.$url + '/authStoreInfo/updateKtng';

            Axios.post(url, this.multipleSelection , this.$store.state.config  ).then(res => {

                //console.log(res );
                let saveCount = res.data;

                    if (saveCount === 999999)
                    {
                        this.loading = false;
                        this.$message.error("동일한 품목이 있습니다. 등록할수 없습니다.");
                    }else {
                        this.loading = false;
                        this.$message.success(saveCount + '건 ' + this.$store.state.saveSuccess);
                        this.search();
                    }

                // this.search();
            }).catch(error => {
                console.log(error.response)
                this.$message.error(this.$store.state.serverErrorMessage);
                this.loading = false;
            }); // await Axios.post

        },


      async insert(){


        if ( this.country.length <=1)
        {
          this.$message.error(" 품목명을 입력해주세요");
          return ;
        }

// 1. 우선 값이 비어있거나 공백만 있는지 체크
          if (!this.amount || this.amount.toString().trim().length === 0) {
              this.$message.error("수량을 입력해주세요");
              return;

          }

// 2. 정규표현식으로 숫자만 있는지 체크 (빈값 통과 방지를 위해 1개 이상 '+' 사용)
          const numericRegex = /^[0-9]+$/;

          if (!numericRegex.test(this.amount)) {
              this.$message.error("수량은 숫자만 입력 가능합니다");
              return;
          }

        var resDataJson  = [];

        resDataJson.push({
          country: this.country,
           amount: this.amount,
          user_seq : 173,
        });
        //
        //
        let url = this.$url + '/authStoreInfo/insert';

        Axios.post(url, resDataJson , this.$store.state.config  ).then(res => {

          //console.log(res );
          let saveCount = res.data;

          if (saveCount === 999999)
          {
              this.loading = false;
              this.$message.error("동일한 품목이 있습니다. 등록할수 없습니다.");
          }else {
              this.loading = false;
              this.$message.success(saveCount + '건 ' + this.$store.state.saveSuccess);
          }
         // this.search();
        }).catch(error => {
          console.log(error.response)
          this.$message.error(this.$store.state.serverErrorMessage);
          this.loading = false;
        }); // await Axios.post

      },



      qrSave2(){
        // this.e.target.files[0].name = "";

        var array = this.qrcode2.split('\n');

        var resDataJson = [];

        for ( var idx = 0 ; idx < array.length  ; idx++ ) {
          resDataJson.push({
            waybill_number: array[idx]
          });
        }


        //console.log ("test ")
        //console.log (array.length )
        //console.log (array[0].trim() )

        if (array.length  <= 1 && array[0].trim() == "")
        {
          resDataJson = [];
          resDataJson.push({
            waybill_number: this.waybill_number
          });
        }

        //console.log (resDataJson )

        let url = this.$url + '/claWayBillInfo/qrInsert2';

        Axios.post(url, resDataJson , this.$store.state.config  ).then(res => {

          //console.log(res );
          let saveCount = res.data;
          this.loading = false;
          this.$message.success(saveCount +'건 ' + this.$store.state.saveSuccess);
          this.search();
        }).catch(error => {
          console.log(error.response)
          this.$message.error(this.$store.state.serverErrorMessage);
          this.loading = false;
        }); // await Axios.post

      },


      submitUpload() {
        this.$refs.upload.submit();
      },



      async excelDownFuncAll(){

        var excepData=[];

            for (var resData in this.totalData) {

              excepData.push({
                일련번호: resData * 1 + 1
                , 작업시간 : this.totalData[resData]['insert_date'].substring(0, 16)
                  , 품목: this.totalData[resData]['country']
                , 수량: this.totalData[resData]['amount']
              });
            }

        var dataWS = XLSX.utils.json_to_sheet(excepData);
        var wb = XLSX.utils.book_new();
        // workbook에 워크시트 추가
        // 시트명은 'nameData'
        XLSX.utils.book_append_sheet(wb, dataWS, 'kt&g품목');
        // 엑셀 파일을 내보낸다.
        this.$store.commit("dayBefore",0); // 오늘날짜
        XLSX.writeFile(wb, "kt&g품목"+'.xlsx');
        this.loading = false;


      },//excelDownFunc

        handleDelete() {
            if (this.multipleSelection.length <= 0) {
                this.$notify.error({
                    title: "데이터를 선택하세요 ",
                    position: "bottom-right",
                    duration: 1500,
                });
                return;
            }

            this.$confirm("삭제 하시겠습니까?", "경고", {
                confirmButtonText: "삭제",
                cancelButtonText: "취소",
                type: "warning",
                // 팝업 전체에 클래스를 입혀서 특정 팝업의 스타일만 바꿉니다.
                customClass: "delete-confirm-box",
            })
                .then(() => {
                    this.remove();
                })
                .catch(() => {
                    console.log("취소");
                });
        },

      async remove(){
        if (this.multipleSelection.length <= 0)
        {
          this.$message.error("데이터를 선택하세요 ");
          return ;
        }
        this.loading = true;
        let url = "";
        url = this.$url + '/authStoreInfo/remove';
        Axios.post(url, this.multipleSelection , this.$store.state.config  ).then(res => {

          //console.log(res );
          let saveCount = res.data;
          this.loading = false;
          this.$message.success(saveCount +'건 삭제 되었습니다.');
          this.search(false);

        }).catch(error => {
          console.log(error.response)
          this.$message.error(this.$store.state.serverErrorMessage);
          this.currentPage = 1;
          this.loading = false;
        }); // await Axios.post
      }, // remove



    }, //methods
  }
</script>


<style>

.el-dialog__body {
  padding: 10px 20px !important;
}

.textarea_class {
  height: 300px !important;
}

.el-textarea__inner {

  height: 100% !important;

}



.searchBody_production {
  width: 100px !important;
  margin-left: 20px !important;
}


.rounded-dialog {
    border-radius: 20px !important;
    overflow: hidden !important;
}

/* 상단 헤더 배경색이나 테두리가 라운드를 가린다면 이것도 추가 */
.rounded-dialog .el-dialog__header {
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
}

::v-deep .rounded-dialog {
    border-radius: 20px !important;
    overflow: hidden;
}

/* 1. 헤더 전체 패딩 조절 (글자가 안 잘리도록 안쪽으로 밀기) */
/* 1. 제목 글자 크기 키우고 밑으로 내리기 */
.rounded-dialog .el-dialog__title {
    font-size: 24px !important;    /* 글자 크기 대폭 확대 */
    font-weight: 800;             /* 더 두껍게 강조 */
    color: #2c3e50;
    display: inline-block;
    padding-top: 8px;             /* 글자를 아래로 살짝 밀어줌 */
}

/* 2. 'X' 버튼 위치도 제목의 중심에 맞춰 재조정 */
.rounded-dialog .el-dialog__headerbtn {
    /* 제목이 커지고 내려왔으므로 'X' 버튼도 같이 조금 내려줘야 수평이 맞습니다 */
    top: 32px !important;
    right: 25px !important;
}

/* 3. 헤더 전체 영역 여유분 확보 */
.rounded-dialog .el-dialog__header {
    padding: 30px 25px 15px !important; /* 상단 패딩을 더 늘려 공간 확보 */
}


/* 1. 버튼들을 감싸는 컨테이너를 가로 정렬(row)로 강제 */
.delete-confirm-box .el-message-box__btns {
    display: flex !important;
    flex-direction: row !important;      /* 가로로 나열 */
    justify-content: flex-end !important; /* 오른쪽 정렬 */
    padding-top: 10px !important;
}

/* 2. 각 버튼이 한 줄을 다 차지하지 않도록 너비 조정 */
.delete-confirm-box .el-message-box__btns .el-button {
    width: auto !important;   /* 혹은 적절한 너비(예: 70px) */
    margin-left: 10px !important; /* 버튼 사이 간격 */
    display: inline-flex !important; /* 버튼 내부 텍스트 정렬 유지 */
    justify-content: center !important;
}

/* 3. 취소 버튼과 확인 버튼의 순서가 바뀌어 보인다면 (필요 시 사용) */
/* Element UI 기본은 취소가 왼쪽(첫번째), 확인이 오른쪽(두번째)입니다. */
.delete-confirm-box .el-message-box__btns button:nth-child(1) {
    order: 1; /* 취소 버튼 */
}
.delete-confirm-box .el-message-box__btns button:nth-child(2) {
    order: 2; /* 확인 버튼 */
}

</style>

